import styles from "./styles.module.scss";
import React, { useState } from "react";
import LeftArrow from "../../../public/images/back-icon.svg";
import { useHistory } from "react-router-dom";
import PagePanel from "app/components/PagePanel";
import ProgramOptions from "./ProgramOptions";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "typedefs";
import { ProgramState } from "../../reducers/scheduling/program";
import GeneralProgramOptions from "./GeneralSettings";
import Navbar from "../../components/Programs/NavBar";
import PricingOptions from "./Pricing";
import DetailsOptions from "./Details";
import RecurringClinicsOptions from "./RecurringClinics";
import { resetProgramSettings } from "../../actions/scheduling/program";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

const generateTitleForCreateProgram = (programType: string, t: TFunction<"translation", undefined>) => {
  if (!programType) {
    return t('Build a Program');
  }
  if (programType === 'Clinic') {
    return t('Drop-In Clinic');
  }
  return t('Build a Series');
};

const BuildProgram = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const programState = useSelector(
    (state: RootState): ProgramState => state.program
  );

  const title = `${programState.edit ? t("Edit") : generateTitleForCreateProgram(programState?.type, t)}`;

  const [header, setHeader] = useState(null);
  const [thumbnail, setThumbanil] = useState(null);
  const [flyer, setFlyer] = useState(null);
  const [headerChanged, setHeaderChanged] = useState(false);
  const [thumbnailChanged, setThumbnailChanged] = useState(false);
  const [flyerChanged, setFlyerChanged] = useState(false);

  const handleHeader = (value) => {
    setHeader(value);
    setHeaderChanged(true);
  };

  const handleThumbnail = (value) => {
    setThumbanil(value);
    setThumbnailChanged(true);
  };

  const handleFlyer = (value) => {
    setFlyer(value);
    setFlyerChanged(true);
  };

  const navigateBack = () => {
    history.goBack();
    dispatch(resetProgramSettings());
  };
  const backButton = () => {
    return (
      <div className={styles.gray_button} onClick={() => navigateBack()}>
        <img
          className={styles.icon}
          style={{
            width: "20px",
            height: "20px",
          }}
          src={LeftArrow}
          alt="info"
        />
      </div>
    );
  };

  const options = [
    { title: t("General"), isActive: programState.page === 1, code: "general" },
    { title: t("Details"), isActive: programState.page === 2, code: "details" },
    { title: t("Pricing"), isActive: programState.page === 3, code: "pricing" },
  ];

  const renderPage = () => {
    switch (programState.page) {
      case 0:
        return <ProgramOptions />;
      case 1:
        return <GeneralProgramOptions />;
      case 2:
        return (
          <DetailsOptions
            setHeader={handleHeader}
            setThumbanil={handleThumbnail}
            setFlyer={handleFlyer}
            flyer={flyer}
          />
        );
      case 3:
        return (
          <PricingOptions
            thumbnailChanged={thumbnailChanged}
            headerChanged={headerChanged}
            flyerChanged={flyerChanged}
            header={header}
            thumbnail={thumbnail}
            flyer={flyer}
          />
        );
      case 4:
        return <RecurringClinicsOptions />;
    }
    return <GeneralProgramOptions />;
  };

  // const pageTitle = useMemo(() => {
  //   if (programState.edit) {
  //     return programState.type ? t("Edit") + " " + programState.type : t("Edit Program")
  //   }
  //   return programState.type ? t("Build") + " " + programState.type : t("Build a Program")
  // }, [programState.edit, programState.type])

  return (
    <div className={styles.page}>
      <PagePanel
        title={t(title)}
        leftButton={backButton()}
      />
      <div className={styles.empty_container}>
        {programState.page !== 0 && programState.page !== 4  && (
          <div className={styles.navbar}>
            <Navbar handleClick={() => null} options={options} isDisabled />
          </div>
        )}
        {renderPage()}
      </div>
    </div>
  );
};

export default BuildProgram;
